import { DevicesTypes } from './types';
import Device from './device';

import cn from './profile.module.css';

const Devices = ({
  devices,
  devicesPagination,
  devicesIsFetching,
  showMore,
  endSession,
  endSessionInProgress,
  endSessionId,
  sessionsIsAvailable,
  onViewSessionClick,
}: DevicesTypes) => {
  let content;

  if (devices && devices.length) {
    content = (
      <div>
        {devices?.map((item) => (
          <Device
            key={item.id}
            device={item}
            endSession={endSession}
            endSessionInProgress={endSessionInProgress}
            endSessionId={endSessionId}
            sessionsIsAvailable={sessionsIsAvailable}
            onViewSessionClick={onViewSessionClick}
          />
        ))}
        {devicesPagination?.hasNextPage && (
          <button
            type="button"
            className={cn.showMore}
            onClick={() => showMore(devicesPagination.endCursor)}
          >
            {devicesIsFetching ? 'Loading...' : 'Show More'}
          </button>
        )}
      </div>
    );
  } else {
    content = <div className={cn.emptyDevices}>No active session yet</div>;
  }

  return content;
};

export default Devices;
